import React, { ReactNode } from "react";
import { HTMLProps } from "react";
import getClasses from "utils/getClasses";
import styles from "./styles.module.css";

type Props = Omit<HTMLProps<HTMLLabelElement>, "title"> & {
  title: ReactNode;
  subTitle?: ReactNode;
  className?: string;
};
const ModalSectionLabel = ({ title, subTitle, className, ...rest }: Props) => (
  <div className={className}>
    <label className={"md-14"} {...rest}>
      {title}
    </label>
    {subTitle && (
      <p
        className={getClasses(
          styles["modal-section-label__subtitle"],
          "rg-11 mb-2",
        )}
      >
        {subTitle}
      </p>
    )}
  </div>
);

export default ModalSectionLabel;
